import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const MigrateSignupFormInputSchema = z.object({
  formId: zExt.objectId(),
});

export const MigrateSignupFormOutputSchema = z.object({
  spotlightId: zExt.objectId(),
});

export type MigrateSignupFormInput = z.infer<
  typeof MigrateSignupFormInputSchema
>;
export type MigrateSignupFormOutput = z.infer<
  typeof MigrateSignupFormOutputSchema
>;

export const migrateSignupForm = {
  name: "migrateSignupForm" as const,
  input: MigrateSignupFormInputSchema,
  output: MigrateSignupFormOutputSchema,
};
